"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("./WidgetError");
/**
 * Error wrapper for knowing which errors were handled and
 * should not be passed to error handler plugins.
 */
class HandledError extends WidgetError_1.default {
    /**
     * Constructs the error.
     *
     * @param {*} parentError
     */
    constructor(parentError) {
        super(parentError.message ? parentError.message : parentError);
        this.parentError = parentError;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, HandledError.prototype);
        this.name = this.getCode();
    }
    /**
     * Gets the actual error.
     *
     * @return {any}
     */
    getActualError() {
        return this.parentError;
    }
}
/**
 * The name of the error.
 *
 * @type {string}
 */
HandledError.code = "SW-HANDLED";
exports.default = HandledError;
